var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_title_bar d_flex pl-8 pt-4 mb-4"},[_c('h1',{staticClass:"title2-medium"},[_vm._v(_vm._s(_vm.title))]),(_vm.isRequired)?_c('p',{staticClass:"title2-medium",staticStyle:{"color":"#FF453A"}},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }